jQuery(document).ready(function($) {

    function loadRepurchaseDocs(page = 1) {

        let filing = $("#filter-filing").val();
        let year   = $("#filter-year").val();
        if (typeof current_page_id !== "undefined" && current_page_id !== "" && typeof fillings_per_page !== "undefined" && fillings_per_page !== "") {
        $.ajax({
            url: localized_object.ajax_url,
            type: "POST",
            data: {
                action: "load_sec_fillings",
                page: page,
                page_id: current_page_id,
                filing: filing,
                year: year,
                per_page: fillings_per_page
            },
            beforeSend: function () {
                if ($("#fillings-table .loader-overlay").length === 0) {
                    $("#fillings-table").append("<div class='loader-overlay'><div class='spinner'></div></div>");
                }
            },
            success: function(response) {
                let data = JSON.parse(response);
                $("#fillings-table").html(data.html);
                $("#fillings-pagination").html(data.pagination);
            },
            complete: function() {
                $(".loader-overlay").remove();
            }
        });
     }
    }

    // load first page
    loadRepurchaseDocs(1);

    // pagination click
    $(document).on("click", ".fillings-page", function(e) {
        e.preventDefault();
        const nextPage = $(this).data("page");
        loadRepurchaseDocs(nextPage);
    });

    // re-load when filters change
    $("#filter-filing, #filter-year").on("change", function() {
        loadRepurchaseDocs(1);
    });

});
